class CartDiscountItem extends Component {
	constructor(el) {
		super(el);
		this.itemDropdown = this.$find('[data-dropdown]');
		this.checkBox = this.$find('input[type=checkbox]');
		this.input = this.$find('input[type=text]');
		this.addBtn = this.$find('[data-add-discount]');
		this.input && this.checkValidity();
		this.toggleDropDown();
		this.addEventListeners();
	}

	toggleDropDown() {
		this.itemDropdown && this.itemDropdown.classList[this.checkBox.checked ? 'add' : 'remove']('is-open');
	}

	checkValidity() {
		this.addBtn.disabled = !this.input.value.length;
	}

	updateCart(e) {
		e.preventDefault();
		EventBus.getInstance().dispatchEvent('orderUpdateStepCart')
	}

	addEventListeners() {
		this.checkBox.addEventListener('change', () => this.toggleDropDown());
		this.addBtn && this.addBtn.addEventListener('click', e => this.updateCart(e));
		!this.itemDropdown && this.checkBox.addEventListener('change', e => this.updateCart(e));
		this.input && this.input.addEventListener('input', () => this.checkValidity());
	}
}
